// Air Zimbabwe official logo (user-provided).
const LOGO_URL = "/brand/air-zimbabwe-logo.png";

export default function AirZimbabweLogo({ className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Air Zimbabwe — Zimbabwean Hospitality in the Skies"
      className={className}
      data-testid="airzim-logo"
      loading="eager"
    />
  );
}
